import { Injectable, PLATFORM_ID, Inject } from "@angular/core";
import { AES, enc, PBKDF2 } from 'crypto-js';
import { isPlatformBrowser } from "@angular/common";
import { Router } from "@angular/router";
var SECRET_KEY = "chair@cvonline9876";
@Injectable({ providedIn: "root" })
export class secureStorage {
    constructor(
        @Inject(PLATFORM_ID) private platformId: Object,
        private router: Router
    ) { }

    setItem(key: any, value: any) {
        if (isPlatformBrowser(this.platformId)) {
            let valuenew = AES.encrypt(value, SECRET_KEY);
            localStorage.setItem(key, valuenew.toString());
            return null;
        } else {
            return null;
        }
    }

    getItem(key: any) {
        if (isPlatformBrowser(this.platformId)) {
            let valuenew = localStorage.getItem(key);
            if (valuenew) {
                let data: any = AES.decrypt(valuenew, SECRET_KEY);
                data = data.toString(enc.Utf8);
                return data;
            } else {
                return null;
            }
        } else {
            return null;
        }
    }

    clear() {
        if (isPlatformBrowser(this.platformId)) {
          var  keys = Object.keys(localStorage),
          i = keys.length;

      while ( i-- ) {
      if(keys[i].startsWith("WZRK")){

      }
      else{
        localStorage.removeItem(keys[i]);
      }
    }
    // localStorage.clear();
            this.router.navigateByUrl("");
            window.location.reload();
        }
    }

    encryptData(data: any) {
        var skey = "edp@$3#drishti"
        var salt = "dRishtI";
        var iterations = 128;
        var bytes = PBKDF2(skey, salt, { keySize: 48, iterations: iterations });
        var iv = enc.Hex.parse(bytes.toString().slice(0, 32));
        var key = enc.Hex.parse(bytes.toString().slice(32, 96));
        var cipherpassword = AES.encrypt(data, key, { iv: iv }).toString();
        return cipherpassword;
    }
    decryptData(data: any) {
        var skey = "edp@$3#drishti"
        var salt = "dRishtI";
        var iterations = 128;
        var bytes = PBKDF2(skey, salt, { keySize: 48, iterations: iterations });
        var iv = enc.Hex.parse(bytes.toString().slice(0, 32));
        var key = enc.Hex.parse(bytes.toString().slice(32, 96));
        var cipherpassword: any = AES.decrypt(data, key, { iv: iv });
        cipherpassword = cipherpassword.toString(enc.Utf8);
        return cipherpassword;
    }

     allStorage() {

        var  keys = Object.keys(localStorage),
          i = keys.length;

      while ( i-- ) {
      if(keys[i].startsWith("WZRK")){

      }
      else{
        localStorage.removeItem(keys[i]);
      }
    }
  }
}
